// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3Lioy","footer":"ReportModalFilter_footer__2se3h"};